module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.prefectures.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onInput]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("都道府県を選択してください。")]), _vm._v(" "), _vm._l((_vm.prefectures), function(prefecture) {
    return _c('option', {
      domProps: {
        "value": prefecture.prefecture_id
      }
    }, [_vm._v("\n    " + _vm._s(prefecture.prefecture_name_full) + "\n  ")])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be385d2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/SelectPrefecture.vue
// module id = 482
// module chunks = 1